import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";
import DropZone from "../components/DropZone";

function resolveSrc(u) { if (!u) return ""; if (u.startsWith("http")) return u; if (u.startsWith("/api/media/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`; return u; }

export default function WeAreThumbnailsEditor() {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/kv/we_are_thumbnails").then(({ data }) => Array.isArray(data) && setItems(data));
  }, []);

  const upd = (i, k, v) => setItems((arr) => { const a = [...arr]; a[i] = { ...a[i], [k]: v }; return a; });
  const add = () => setItems((arr) => arr.length >= 4 ? arr : [...arr, { src: "", alt: "", link: "" }]);
  const remove = (i) => setItems((arr) => arr.filter((_, j) => j !== i));

  const save = async () => {
    setSaving(true);
    try { await api.put("/content/kv/we_are_thumbnails", { value: items.slice(0, 4) }); toast.success("Thumbnails atualizadas."); }
    catch { toast.error("Erro ao salvar."); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex justify-between items-end mb-6">
        <div>
          <h1 className="font-display text-4xl">"We are PLACES" — Thumbnails</h1>
          <p className="text-sm text-neutral-500 mt-1">Linha de até 4 imagens na proporção 16:9 (1920×1080) que aparece no manifesto da home.</p>
        </div>
        <button onClick={save} disabled={saving} data-testid="we-are-save" className="bg-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-accent-orange disabled:opacity-50"><Save className="w-3 h-3 inline mr-1" /> {saving ? "Salvando…" : "Salvar"}</button>
      </div>

      <section className="border border-black/10 p-5 rounded">
        <div className="flex justify-between items-center mb-4">
          <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700">Thumbs ({items.length} / 4)</div>
          <button onClick={add} disabled={items.length >= 4} className="text-xs bg-accent-yellow px-3 py-1 rounded-full font-semibold disabled:opacity-50" data-testid="we-are-add"><Plus className="w-3 h-3 inline" /> Adicionar</button>
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((tn, i) => (
            <div key={i} className="border border-black/10 p-4 rounded space-y-2" data-testid={`we-are-${i}`}>
              <div className="flex justify-between items-center">
                <div className="text-xs font-semibold text-neutral-500">Thumb {i + 1}</div>
                <button onClick={() => remove(i)} className="text-red-500"><Trash2 className="w-4 h-4" /></button>
              </div>
              {tn.src && <img src={resolveSrc(tn.src)} alt="" className="w-full aspect-video object-cover rounded" />}
              <DropZone multiple={false} onUploaded={(f) => upd(i, "src", f.url)} />
              <input value={tn.src || ""} onChange={(e) => upd(i, "src", e.target.value)} placeholder="URL" className="w-full text-xs border border-black/15 px-2 py-1.5 rounded" />
              <input value={tn.alt || ""} onChange={(e) => upd(i, "alt", e.target.value)} placeholder="Texto descritivo (aparece em hover)" className="w-full border border-black/15 px-2 py-1.5 rounded text-sm" />
              <input value={tn.link || ""} onChange={(e) => upd(i, "link", e.target.value)} placeholder="Link (opcional)" className="w-full border border-black/15 px-2 py-1.5 rounded text-sm" />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
